<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12">

            <CRow>
              <!-- Page Title -->
              <h3 class="text-left mt-4 ml-5 text-black bold col-10">
                Teacher Quiz List
                <img src="../assets/img/quizLists.png" width="120px" />
              </h3>

              <!-- Quiz List -->
              <div class="col-lg-12">
                <CRow>
                  <CCol>

                    <CCard
                      v-for="item in quizDetail"
                      v-bind:key="item.subjectId"
                      style="border-radius: 20px"
                      class="box-shadow"
                    >
                      <div
                        style="
                          border-top-right-radius: 10px;
                          border-top-left-radius: 10px;
                        "
                        class="bg-gradient-turqouise-no p-2"
                      >
                      <div class="row">
                        <div class="col-10">

                        <h6 class="mt-2 text-left ml-2">{{ item.Title }}</h6>
                        </div>
                        <div class="col-2">

                         <CLink
                            class="card-header-action btn-minimize"
                            @click="GotoPageQuestionDescription(item.Id)"
                            v-c-tooltip.hover.click="
                              'Click to view the Detail!'
                            "
                          >
                            <CIcon name="cil-arrow-thick-right" class="text-left text-white" />
                          </CLink>
                        </div>
                      </div>
                      </div>
                      <div class="text-left ml-3">

                        <h6 class="custom-font mt-4">Grade:
                         <strong>  {{ item.gradeName }} </strong>
                        </h6>

                        <h6 class="custom-font">
                          Created Date: <strong>{{ item.CreatedDate | moment("DD MMMM YYYY")}} </strong>
                        </h6>

                        <h6 class="custom-font">
                           <span class="text-left">Question Amount: <strong> {{ item.questionCount }}</strong></span>
                        </h6>

                          
                        <h6 class="custom-font">Time:
                         <strong>   {{ item.TimerString }} </strong>
                        </h6>

                         <h6 class="custom-font">Quiz Id:
                         <strong>   {{ item.Id }} </strong>
                        </h6>

                        <h6 class="custom-font">
                          <label v-if="item.IsPublish === true">
                            Status
                          <CBadge color="success" class="fontlist">
                            Published</CBadge
                          ></label
                        >
                        <label v-else
                          >Status
                          <CBadge color="warning" class="fontlist">
                            Pending</CBadge
                          ></label
                        >
                        </h6>
                        <br />
                      </div>
                    </CCard>
                  </CCol>
                </CRow>
              </div>
            </CRow>

            <div>
              <CButton
                color="success"
                class="custom-btn mt-1 mb-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToDashBoard"
                >Close</CButton
              >
            </div>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebTutor.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      quizDetail: [],
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false
    };
  },
  async mounted() {
    this.GetQuizDetails();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizDetails() {
      this.$API
        .get(
          this.$ListTeacherQuizBySubjectId +
            "?userId=" +
            this.$route.query.userId +
            "&subjectId=" +
            this.$route.query.subjectId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.quizDetail = response.data;
            console.log(this.quizDetail);
          }
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },
    GotoPageQuestionDescription(quizId) {
      this.$router.push(
        "/QuizTeacherDescription?quizId=" +
          quizId +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizTeacherDashboard?userId=" + this.$route.query.userId
      );
    }
  }
};
</script>

<style>
.fontlist {
  font-size: 13px;
}
#fb-root{
  display:none;
}
</style>